export function getKeyByValue(object: {[key: string]: string}, value: string) {
  return Object.keys(object).find(key => object[key] === value);
}

export function isProduction() {
  return process.env.REACT_APP_ENV === 'production'
}